"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntersectionTrackerTags = void 0;
var IntersectionTrackerTagMap = [['article', 'article'], ['aside', 'aside'], ['div', 'div'], ['span', 'span'], ['footer', 'footer'], ['header', 'header'], ['section', 'section'], ['ul', 'ul'], ['ol', 'ol'], ['li', 'li']];
exports.IntersectionTrackerTags = new Map(IntersectionTrackerTagMap);